<template>
  <div class="card_template_wrap">
    <common-header show-search show-border @search="search" placeholder="请输入卡模板名称">
      <el-button size="medium" type="primary" @click="toAddCardModule">添加卡模板</el-button>
      <el-select v-model="query.templateAxis" placeholder="请选择分类" size="medium" @change="getIntegralCardTemplateSchList()">
          <el-option label="竖版" :value="2"></el-option>
          <el-option label="横版" :value="1"></el-option>
        </el-select>
        <el-select v-model="query.groupName" placeholder="请选择分类" size="medium" @change="getIntegralCardTemplatePageList()">
              <el-option label="全部分类" :value="''"></el-option>
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.value" :value="item.value"></el-option>
            </el-select>
           <el-select v-model="query.fromSchId" placeholder="请选择分类" size="medium" @change="getIntegralCardTemplatePageList()">
              <el-option label="全部学校" :value="0"></el-option>
              <el-option v-for="(item, index) in datalist" :key="index" :label="item.fromSchName" :value="item.fromSchId"></el-option>
            </el-select>
    </common-header>
    <div class="card_template_box" :style="`height: ${windowHeight - 225}px;`">
      <div class="card_template_list">
        <div class="card_template_item"  :key="index" v-for="(item, index) in cardList">
          <img :src="item.frontUrl" :class="{'hengshu' : item.templateAxis==1}" alt="" @click="toTemplateInfo(item.id)">
          <div>{{item.name}}</div>
        </div>
      </div>
    </div>

    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="query.pageNo" :page-sizes="[10,20,30, 50]"
                     :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import {getIntegralCardTemplatePageList,getIntegralCardTemplateSchList} from '@/api/integralBank';
  import CommonHeader from '@/components/CommonHeader';
  import {findDicsByCode} from '@/api/common/common';
  export default {
    name: "cardTemplateList",
    components: {CommonHeader},
    data() {
      return {
        total: null,
        query: {
          pageNo: 1, //页数
          pageSize: 10,//条数
          name: '',
          templateAxis:2,
          fromSchId:0,
          groupName:""
        },
        cardList: [],
        datalist:[],
        typeList:[]
      }
    },
    mixins: [windowResize],
    activated(){
       this.getIntegralCardTemplatePageList();
    },
    created() {
        findDicsByCode({dicCode: 'integralCardTemplateGroup'}).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.typeList = data.data;
          }
        });
      this.getIntegralCardTemplateSchList();
    },
    methods: {
      toAddCardModule() {
        this.$router.push({path: 'cardTemplateAdd'})
      },
      toTemplateInfo(templateId) {
        this.$router.push({path: 'cardTemplateInfo', query: {templateId: templateId}})
      },
      search(val) {
        this.query.pageNo = 1;
        this.query.name = val;
        this.getIntegralCardTemplatePageList();
      },
      getIntegralCardTemplateSchList() {
        getIntegralCardTemplateSchList({templateAxis:this.query.templateAxis}).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.datalist = data.data;
          }          
         this.getIntegralCardTemplatePageList();
        });
      },
      getIntegralCardTemplatePageList() {
        getIntegralCardTemplatePageList(this.query).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.cardList = data.data.dataList;
            this.total = data.data.pagination.total;
          }
        });
      },
      handleSizeChange(val) {
        this.query.pageNo = 1;
        this.query.pageSize = val;
        this.getIntegralCardTemplatePageList();
      },
      handleCurrentChange(val) {
        this.query.pageNo = val;
        this.getIntegralCardTemplatePageList();
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../styles/mixin';

  .card_template_wrap{
    padding: 12px;

    .card_template_box{
      @include scrollBar;
      .card_template_list{
        @include clearfix;
        padding-top: 15px;
        .card_template_item{
          float: left;
          margin-bottom: 30px;
          img{
            display: block;
            width: 182px;
            height: 273px;
            margin: 0 auto;
            cursor: pointer;
          }
          .hengshu{
            height: 182px;
            width: 273px;
          }
          div{
            width: 249px;
            height: 30px;
            line-height: 30px;
            margin-top: 5px;
            text-align: center;
            font-weight: bold;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/integralBank/cardTemplateList.vue